import { pinia } from '@tools/pinia';
import { createApp } from 'vue';
import CombinatorChoose from '@pages/offer-page/combinator/CombinatorChoose.vue';

export const combinator = () => {
  const app = createApp(CombinatorChoose);

  app.use(pinia);
  app.mount('#combinator-choose-app');
};
